
















































































































































































































































































import {
  Component,
  Mixins,
  Prop,
} from 'vue-property-decorator';
import {
  Mutation,
  Action,
} from 'vuex-class';

import DateField from '@/components/FormBuilder/fields/DateField.vue';
import ObjectField from '@/components/FormBuilder/fields/ObjectField.vue';
import ObjectFieldNormalizer from '@/classes/normalizers/field-normalizers/ObjectFieldNormalizer';
import FakeNormalizer from '@/classes/normalizers/field-normalizers/FakeNormalizer';
import { FieldNormalizer } from '@/classes/normalizers/types';
import WorkReadCollection from '@/components/ApplicationHR/WorkReadCollection.vue';
import WorkReadEditCollection from '@/components/ApplicationHR/WorkReadEditCollection.vue';
import BooleanField from '@/components/FormBuilder/fields/BooleanField.vue';
import TimeField from '@/components/FormBuilder/fields/TimeField.vue';
import RepeatableInputGroup from '@/components/common/RepeatableInputGroup.vue';
import UserMixin from '@/mixins/UserMixin';
import NormalizerMixin from '@/mixins/NormalizerMixin';
import { CrudOperation } from '@/types/CrudOperation';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import axios from 'axios';
import { graphqlEndpoints } from '@/utils/config';
import { cloneDeep } from 'lodash';

enum ProcessApplicationActions {
  CANCEL = 'cancel',
  APPROVE = 'approve',
  SAVE = 'save',
}

@Component({
  components: {
    DateField,
    ObjectField,
    WorkReadCollection,
    WorkReadEditCollection,
    BooleanField,
    TimeField,
    RepeatableInputGroup,
  },
})
export default class ReadForm extends Mixins(UserMixin, NormalizerMixin, EntityHelperMixin) {
  @Prop({ default: () => ({}) })
  entityData!: any;

  entityDataInternal: any = {
    night: [],
    day: [],
  };

  entityDataInternalInitial: any = {
    night: [],
    day: [],
  };

  loading = true;

  availableSuppliers = [];

  interchangedData: Record<string, any> = {};

  booleanFields = [
    {
      label: 'Тяжелый',
      fieldName: 'category',
    },
    {
      label: 'Техника',
      fieldName: 'technology',
    },
    {
      label: 'ПК',
      fieldName: 'PC',
    },
  ]

  @Mutation('setOperation', { namespace: 'entity' })
  setOperation!: (operation: CrudOperation) => void;

  @Action('toggleEntityModal', { namespace: 'entity' })
  toggleEntityModal: any;

  async beforeMount() {
    this.entityDataInternal = cloneDeep(this.entityData);
    this.entityDataInternal = this.processOperationsToDayNight(this.entityDataInternal);
    this.entityDataInternalInitial = cloneDeep(this.entityDataInternal);
    this.availableSuppliers = await this.loadSuppliers();
    this.loading = false;
  }

  processOperationsToDayNight(data: any) {
    if (!data?.operationWorks?.length) {
      return data;
    }
    const dayArray = data.operationWorks.filter((v: any) => v.time_interval === 'day');
    const nightArray = data.operationWorks.filter((v: any) => v.time_interval === 'night');
    if (dayArray?.length) {
      data.day = dayArray;
    }
    if (nightArray?.length) {
      data.night = nightArray;
    }
    return data;
  }

  async loadSuppliers() {
    return this.loadEntityListing('Supplier', {}, 'network-only', {
      maxDepth: 1,
      byObject: this.getNormalizerRequiredFields('Supplier'),
    });
  }

  get isHRRework() {
    return Boolean(this.isHR && this.entityDataInternal?.status?.code === 'HR_rework');
  }

  get isSupplierCacnelled() {
    return Boolean(this.isHR && this.entityDataInternal?.status?.code === 'supplier_cancelled');
  }

  get isHRApproval() {
    return Boolean(this.isHR && this.entityDataInternal?.status?.code === 'HR_approve');
  }

  get isSupplierConfirmation() {
    return Boolean(this.isSupplier && this.entityDataInternal?.status?.code === 'supplier_confirmation');
  }

  get isSupplierApproval() {
    return Boolean(this.isSupplier && this.entityDataInternal?.status?.code === 'supplier_approve');
  }

  get isCoordinatorConfirmation() {
    return Boolean(this.isCoordinator && this.entityDataInternal?.status?.code === 'coordinator_confirmation');
  }

  get isCreatedCancelAllowed() {
    return Boolean((this.isCoordinator || this.isHR) && this.entityDataInternal?.status?.code === 'created');
  }

  get isEditable() {
    return Boolean(
      (this.isHR || this.isCoordinator) && (
        this.entityDataInternal?.status?.code === 'supplier_confirmation' || this.entityDataInternal?.status?.code === 'in_progress'
      ),
    );
  }

  workDataNormalize(data: Array<any>) {
    if (!data) {
      return [];
    }
    return data.map((v) => {
      const preparedWork = { ...v };
      for (let i = 0; i < this.workDataOptions.length; i += 1) {
        const workDataOptions = this.workDataOptions[i];
        preparedWork[workDataOptions.value] = this.normalizeValue(v[workDataOptions.value]);
      }
      return preparedWork;
    });
  }

  get workHeaders() {
    return this.workDataOptions.map((v: any) => ({
      text: v.text,
      value: v.value,
    }));
  }

  get workDataOptions(): Array<{ text: any; value: string; normalizer?: any }> {
    return [
      {
        text: this.$t('workType'),
        value: 'workType',
      },
      {
        text: this.$t('time_from'),
        value: 'time_from',
      },
      {
        text: this.$t('time_to'),
        value: 'time_to',
      },
      {
        text: this.$t('size'),
        value: 'size',
      },
      {
        text: this.$t('units'),
        value: 'units',
      },
      {
        text: this.$t('quantity'),
        value: 'quantity',
      },
      {
        text: this.$t('PC'),
        value: 'PC',
      },
      {
        text: this.$t('category'),
        value: 'category',
      },
      {
        text: this.$t('technology'),
        value: 'technology',
      },
    ];
  }

  /**
  * this one is for when HR reworking as general application to reassign to different suppliers
  */
  buildFormData(normalizer: FieldNormalizer = new ObjectFieldNormalizer()) {
    const originalApplication = this.entityDataInternal;
    const interchangedData = this.interchangedData;
    return {
      date_from: originalApplication.date_from,
      date_to: originalApplication.date_to,
      platform: normalizer.normalize(originalApplication.platform),
      coordinator: normalizer.normalize(originalApplication.coordinator),
      client: normalizer.normalize(originalApplication.client),
      night_work: interchangedData.night
        ? this.buildWorkCollection(originalApplication.night || [], interchangedData.night, normalizer)
        : originalApplication.night,
      day_work: interchangedData.day
        ? this.buildWorkCollection(originalApplication.day || [], interchangedData.day, normalizer)
        : originalApplication.day,
      jbpm_process_id: originalApplication.jbpm_process_id,
      jbpm_container_id: originalApplication.jbpm_container_id,
      day_comment: originalApplication.day_comment,
      night_comment: originalApplication.night_comment,
    };
  }

  /**
  * this one is for simple application hr build
  */
  buildFormDataApplicationHr(normalizer: FieldNormalizer = new ObjectFieldNormalizer()) {
    const originalApplication = this.entityDataInternal;
    const interchangedData = this.interchangedData;
    const nightWorkArray = this.buildWorkCollectionApplicationHr(originalApplication.night || [], interchangedData.night, normalizer).items.Work;
    const dayWorkArray = this.buildWorkCollectionApplicationHr(originalApplication.day || [], interchangedData.day, normalizer).items.Work;
    const formData = {
      date_from: originalApplication.date_from,
      date_to: originalApplication.date_to,
      platform: normalizer.normalize(originalApplication.platform),
      coordinator: normalizer.normalize(originalApplication.coordinator),
      client: normalizer.normalize(originalApplication.client),
      status: normalizer.normalize(originalApplication.status),
      Supplier: normalizer.normalize(originalApplication.Supplier),
      medical_book: originalApplication.medical_book,
      day_comment: originalApplication.day_comment,
      night_comment: originalApplication.night_comment,
      // night: this.buildWorkCollectionApplicationHr(originalApplication.night || [], interchangedData.night, normalizer),
      // day: this.buildWorkCollectionApplicationHr(originalApplication.day || [], interchangedData.day, normalizer),
      operationWorks: [...this.buildOperationWorks(nightWorkArray, 'night'), ...this.buildOperationWorks(dayWorkArray, 'day')],
      jbpm_process_id: originalApplication.jbpm_process_id,
      jbpm_container_id: originalApplication.jbpm_container_id,
    };
    return formData;
  }

  buildOperationWorks(collection: Array<any>, time_of_day: 'day' | 'night') {
    return collection.map((v: any) => {
      v.time_interval = time_of_day;
      return v;
    });
  }

  buildWorkCollection(originalCollection: any, interchangedData: any, normalizer: FieldNormalizer) {
    const collection: Array<any> = [];
    for (let i = 0; i < originalCollection.length; i += 1) {
      const item = originalCollection[i];
      const interchangedItem = {
        supplier: interchangedData.suppliers[i],
        comment: interchangedData.comments[i],
      };
      const suppliers_with_v: Array<any> = [];
      suppliers_with_v.push({
        supplier: normalizer.normalize(interchangedItem.supplier),
        size: String(item.size),
        quantity: String(item.quantity),
      });
      collection.push({
        suppliers_with_v,
        work_type: normalizer.normalize(item.workType),
        units: normalizer.normalize(item.units),
        time_from: item.time_from,
        time_to: item.time_to,
        PC: item.PC,
        technology: item.technology,
        category: item.category,
      });
    }
    return {
      items: {
        GeneralWork: collection,
      },
    };
  }

  buildWorkCollectionApplicationHr(originalCollection: any, interchangedData: any, normalizer: FieldNormalizer) {
    const collection: Array<any> = [];

    for (let i = 0; i < originalCollection.length; i += 1) {
      const item = originalCollection[i];
      const interchangedItem = interchangedData && interchangedData[i];

      collection.push({
        workType: normalizer.normalize(item.workType),
        units: normalizer.normalize(item.units),
        time_from: item.time_from,
        time_to: item.time_to,
        PC: item.PC,
        technology: item.technology,
        category: item.category,
        quantity: interchangedItem ? interchangedItem.quantity : item.quantity,
        size: item.size,
        id: parseInt(item.id, 10),
        actual_size: item.actual_size,
        actual_quantity: item.actual_quantity,
        actual_work_time: item.actual_work_time,
        date: item.date,
        application: normalizer.normalize(this.entityDataInternal),
        comment: item.comment,
        time_interval: item.time_interval,
      });
    }
    return {
      items: {
        Work: collection,
      },
    };
  }

  dataEditChanged(data: any, work: string) {
    this.interchangedData[work] = data;
  }

  dataReadChanged(data: any, parameter: string) {
    this.entityDataInternal[parameter] = data;
  }

  async cancelApplication() {
    let response: any;
    if (this.isHRApproval) {
      // eslint-disable-next-line max-len
      response = await this.processApplication(graphqlEndpoints.processHRApplication, ProcessApplicationActions.CANCEL, this.buildFormDataApplicationHr());
    }
    if (this.isHRRework || this.isSupplierCacnelled) {
      // eslint-disable-next-line max-len
      response = await this.processApplication(graphqlEndpoints.processHRReworkApplication, ProcessApplicationActions.CANCEL, this.entityDataInternal);
    }
    if (this.isCreatedCancelAllowed || this.isCoordinatorConfirmation) {
      // eslint-disable-next-line max-len
      response = await this.processApplication(graphqlEndpoints.processCoordinatorApplication, ProcessApplicationActions.CANCEL, this.entityDataInternal);
    }
    this.closeModalAndRefresh(response);
  }

  async cancelApplicationSupplier() {
    // eslint-disable-next-line max-len
    const response = await this.processApplication(graphqlEndpoints.processSupplierApplication, ProcessApplicationActions.CANCEL, this.buildFormDataApplicationHr());
    this.closeModalAndRefresh(response);
  }

  async sendApplication() {
    let response: any;
    if (this.isHRApproval) {
      response = await this.processApplication(graphqlEndpoints.processHRApplication, ProcessApplicationActions.APPROVE, this.entityDataInternal);
    }
    if (this.isHRRework || this.isSupplierCacnelled) {
      response = await this.processApplication(graphqlEndpoints.processHRReworkApplication, ProcessApplicationActions.SAVE, this.buildFormData());
    }
    if (this.isCoordinatorConfirmation) {
      // eslint-disable-next-line max-len
      response = await this.processApplication(graphqlEndpoints.processCoordinatorApplication, ProcessApplicationActions.APPROVE, this.entityDataInternal);
    }
    this.closeModalAndRefresh(response);
  }

  async sendApplicationSupplier() {
    // eslint-disable-next-line max-len
    const response = await this.processApplication(graphqlEndpoints.processSupplierApplication, ProcessApplicationActions.APPROVE, this.buildFormDataApplicationHr());
    this.closeModalAndRefresh(response);
  }

  async sendApplicationEdit() {
    if (this.isEditable) {
      const response = await this.processApplication(
        graphqlEndpoints.processEditApplication, ProcessApplicationActions.SAVE, this.buildFormDataApplicationHr(),
      );
      this.closeModalAndRefresh(response);
    }
  }

  async processApplication(url: string, action: ProcessApplicationActions, application: any) {
    const requestBody = {
      application,
      action,
    };
    let response: any = null;
    this.loading = true;
    try {
      console.log('url:', url);
      console.log('request body:');
      console.log(requestBody);
      console.log(JSON.stringify(requestBody));
      response = await axios.put(url, requestBody);
      this.$bus.$emit('notification', 'Операция выполнена', 'success');
    } catch (e) {
      this.$bus.$emit('notification', 'Не удалось выполнить операцию', 'warning');
      console.log(e);
    }
    console.log('response from talend:');
    console.log(response);
    this.loading = false;
    return response;
  }

  closeModalAndRefresh(response: any) {
    if (!response) {
      console.error(response);
      return;
    }
    this.toggleEntityModal(false);
    this.$bus.$emit('entity-refetch');
  }

  preview() {
    // const { date_from, date_to } = this.entityDataInternal;
    // const supplier = this.entityDataInternal.Supplier?.legal_name;
    // const day = this.entityDataInternal.day || [];
    // const night = this.entityDataInternal.night || [];

    // const prepareWorks = (works: Record<string, any>[]) => works.map((work: Record<string, any>) => ({
    //   work_type: work.work_type || '',
    //   recommend_quantity: work.quantity,
    //   size: work.size,
    //   supplier,
    //   units: work.units || '',
    // }));
    // const preparedData = {
    //   date_from,
    //   date_to,
    //   day_work: prepareWorks(day),
    //   night_work: prepareWorks(night),
    // };
    this.setOperation(CrudOperation.preview);
    this.$bus.$emit('preview', {
      data: this.buildFormData(new FakeNormalizer()),
    });
  }
}
